"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuButton = void 0;
/**
 * Created by jonas on 2024-05-15.
 */
const GuiButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton");
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const PromoPanelAssetConfig_1 = require("./config/PromoPanelAssetConfig");
class MenuButton extends GuiButton_1.GuiButton {
    constructor(name, config) {
        super(name);
        this._toggled = false;
        this.ring = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.NAV_ACTIVE));
        this.ring.tint = config.color;
        this.normalTexture = ImgLoader_1.ImgLoader.getImgTexture(config.buttonTextureName);
        this.disabledTexture = ImgLoader_1.ImgLoader.getImgTexture(config.buttonDisabledTextureName);
        this.icon = new PIXI.Sprite();
        this.icon.position.set(12, 12);
        this.addChild(this.icon, this.ring);
    }
    enable(value) {
        super.enable(value);
        this.icon.texture = value === true ? this.normalTexture : this.disabledTexture;
    }
    get toggled() {
        return this._toggled;
    }
    set toggled(value) {
        this.ring.alpha = value ? 1 : 0;
        this._toggled = value;
    }
}
exports.MenuButton = MenuButton;
//# sourceMappingURL=MenuButton.js.map